import { FC } from 'react';
import { useTowerLayout } from './TowerLayoutProvider';

const BreakingPointsWrapper: FC = ({ children }) => {
    const { isBreakingPointsEnabled } = useTowerLayout();
    const getBreakingPointsClass = () => {
        if (isBreakingPointsEnabled) {
            return 'w-full max-w-full 2xl:max-w-[1400px] 3xl:max-w-[1800px] mx-auto';
        }
        return '';
    };

    return <div className={`h-full flex-1 overflow-auto relative  ${getBreakingPointsClass()}`}>{children}</div>;
};

export default BreakingPointsWrapper;
